<template>
  <el-dialog title="预约订单" :visible.sync="visible" width="500px" center>
    <el-form :model="reserveForm" :rules="rules" ref="reserveForm" label-width="110px" >
      <el-form-item label="预约回收日期" required>
        <div style="display: flex; gap: 10px;">
          <el-form-item prop="date" style="margin-bottom: 0; flex: 1;">
            <el-date-picker
              v-model="reserveForm.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="timeRange" style="margin-bottom: 0; flex: 1.2;">
            <el-time-picker
              is-range
              v-model="reserveForm.timeRange"
              arrow-control
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              placeholder="选择时间段"
              format="HH:mm"
              value-format="HH:mm:00"
              style="width: 100%"
            >
            </el-time-picker>
          </el-form-item>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="padding-bottom: 20px;">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ReserveOrderDialog',
  data() {
    return {
      visible: false,
      loading: false,
      reserveForm: {
        orderNum: '',
        date: '',
        timeRange: null
      },
      rules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        timeRange: [
          { required: true, message: '请选择时间段', trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate: (time) => {
          const now = new Date();
          now.setHours(0, 0, 0, 0);
          const thirtyDaysLater = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
          return time.getTime() < now.getTime() || time.getTime() > thirtyDaysLater.getTime();
        }
      }
    };
  },
  methods: {
    open(orderNum) {
      this.reserveForm.orderNum = orderNum;
      this.reserveForm.date = '';
      this.reserveForm.timeRange = null;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.reserveForm.clearValidate();
      });
    },
    handleConfirm() {
      this.$refs.reserveForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const params = {
            orderNum: this.reserveForm.orderNum,
            appointDate: this.reserveForm.date + ' ' + this.reserveForm.timeRange[0],
            appointmentEndTime: this.reserveForm.date + ' ' + this.reserveForm.timeRange[1]
          };
          this.HttpService.post('/autoapp-default-server-recovery/api/self-recycle/appoint', params)
            .then(res => {
              if (res.statusCode === 200) {
                this.$message.success('预约成功');
                this.visible = false;
                this.$emit('success');
              } else {
                this.$message.error(res.message || '预约失败');
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/ReserveOrderDialog.vue